import React from "react";
import { GiCardJoker } from "react-icons/gi";

const Photoframe = ({ title, des, img }) => {
  return (
    <article
      className="w-full flex flex-col items-center justify-center 
  rounded-2xl border-2 border-solid border-slate-800  bg-white p-6 relative 
  hover:shadow-none  
    xs:p-4"
    >
      <div className="w-full h-auto">
        <div>
          <img
            src={img}
            alt={title}
            className="w-full h-[500px]"
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.2 }}
          />
        </div>
        <div className="text-black  p-2 text-center">
          <h3 className="text-2xl">{title}</h3>
          <h3 className="text-lg">{des}</h3>
        </div>
      </div>
    </article>
  );
};

export default Photoframe;
